import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-74fb524a"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "box mb-2"
};
var _hoisted_2 = {
  class: "info text-ellipsis flex align-center justify-between"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "总预算收入/元", -1);
});
var _hoisted_4 = {
  class: "value"
};
var _hoisted_5 = {
  class: "info text-ellipsis flex align-center justify-between"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "总实际收入/元", -1);
});
var _hoisted_7 = {
  class: "value"
};
var _hoisted_8 = {
  class: "info text-ellipsis flex align-center justify-between"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "执行率", -1);
});
var _hoisted_10 = {
  class: "value"
};
var _hoisted_11 = {
  class: "box mb-2"
};
var _hoisted_12 = {
  class: "info text-ellipsis flex align-center justify-between"
};
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "总预算支出/元", -1);
});
var _hoisted_14 = {
  class: "value"
};
var _hoisted_15 = {
  class: "info text-ellipsis flex align-center justify-between"
};
var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "总实际支出/元", -1);
});
var _hoisted_17 = {
  class: "value"
};
var _hoisted_18 = {
  class: "info text-ellipsis flex align-center justify-between"
};
var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "执行率", -1);
});
var _hoisted_20 = {
  class: "value"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.emptyStringFormat(_ctx.item.totalBudgetReceipt)), 1)]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.emptyStringFormat(_ctx.item.totalActualReceipt)), 1)]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.emptyStringFormat(_ctx.item.receiptImplementRate)) + "%", 1)])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.emptyStringFormat(_ctx.item.totalBudgetPay)), 1)]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.emptyStringFormat(_ctx.item.totalActualPay)), 1)]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.emptyStringFormat(_ctx.item.payImplementRate)) + "%", 1)])])]);
}